import React from 'react';
import { Home } from 'components/home';
import {ErrorBoundary} from 'components/errorBoundary'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import 'App.css';

const theme = createMuiTheme();
const App = () => (
  <MuiThemeProvider theme={theme}>
    <ErrorBoundary><Home /></ErrorBoundary>
  </MuiThemeProvider>
)
    ;

export default App;
